







import { Filter } from "@/utils/decorator";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class CustomPhoneLabel extends Vue {
  @Prop({ default: "" }) title?: string;
  @Prop({ default: "" }) value?: string;

  @Filter()
  phoneFormat(value: string) {
    const regexp = /\B(?=(\d{4})+(?!\d))/g;
    return value.toString().replace(regexp, "-");
  }
}
